<template>
  <div class="mt-6">
    <button expand="block" color="secondary" class="button-purple mt-4 mb-6" @click="$router.push('tabs/home')">
      <span class="block capitalize text-white font-semibold height-[60px]">Back to Home</span>
    </button>
  </div>
</template>